class PaymailServerError extends Error {

}

export { PaymailServerError }
